import React, { useEffect, useState } from 'react';
import FormModal from '../Modals/FormModal';
import SelectField from '../Forms/Input/SelectField';
import FileUploader from '../Uploader/FileUploader';
import clsx from 'clsx';
import { CertificateFileType } from '../../types/certificate/certificate';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (file: File, fileType: CertificateFileType) => void;
  isSubmitting: boolean;
}

const TaxpayerCertificateUploadModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting,
}) => {
  const [fileType, setFileType] = useState<CertificateFileType | ''>('');

  const [file, setFile] = useState<File | null>(null);

  useEffect(() => {
    if (isOpen) {
      setFileType('');
      setFile(null);
    }
  }, [isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!fileType || !file) return;

    // ✅ Llamas correctamente pasando los parámetros en orden
    onSubmit(file, fileType);
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        fileType === 'CERTIFICATE'
          ? 'Subir Certificado'
          : fileType === 'PRIVATE_KEY'
          ? 'Subir Clave Privada'
          : fileType === 'PUBLIC_KEY'
          ? 'Subir Clave Pública'
          : 'Subir Archivo'
      }
      maxWidth="max-w-xl"
    >
      <form onSubmit={handleSubmit} className="mt-4 grid grid-cols-1 gap-6">
        <SelectField
          label="Tipo de Archivo"
          name="fileType"
          value={fileType}
          onChange={(e) => setFileType(e.target.value as CertificateFileType)}
          options={[
            { label: 'Certificado', value: 'CERTIFICATE' },
            { label: 'Clave privada', value: 'PRIVATE_KEY' },
            { label: 'Clave pública', value: 'PUBLIC_KEY' },
          ]}
          placeholder="Seleccione tipo de archivo"
          iconKey='list'
        />

        <FileUploader
          currentFile={file}
          onFileChange={setFile}
          onRemoveFile={() => setFile(null)}
          label="Seleccione archivo (.crt o .key)"
          accept=".crt,.key"
          iconKey="upload"
        />

        <button
          type="submit"
          disabled={isSubmitting}
          className={clsx(
            'w-full rounded px-4.5 py-2.5 font-medium text-white',
            isSubmitting
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-primary hover:bg-opacity-90'
          )}
        >
          {isSubmitting ? 'Subiendo...' : 'Subir Archivo'}
        </button>
      </form>
    </FormModal>
  );
};

export default TaxpayerCertificateUploadModal;
